import { useState } from "react";
import versiculos from "../versiculos";

export default function Versiculo({ referencia }) {
  const [mostrar, setMostrar] = useState(false);

  return (
    <span
      style={{
        color: "#9b2a92",
        cursor: "pointer",
        position: "relative",
        fontWeight: "bold",
        fontSize: "1rem",
        display: "inline-block",
        textDecoration: "underline",
      }}
      onMouseEnter={() => setMostrar(true)}
      onMouseLeave={() => setMostrar(false)}
      onClick={() => setMostrar(!mostrar)} // Compatible con móviles
    >
      {referencia}

      {mostrar && (
        <div
          style={{
            position: "absolute",
            bottom: "140%",
            left: "50%",
            transform: "translateX(-50%)",
            width: "360px",
            background: "#fff",
            color: "#333",
            padding: "15px",
            borderRadius: "12px",
            boxShadow: "0 15px 40px rgba(0,0,0,.25)",
            zIndex: 999999,
          }}
        >
          <strong
            style={{
              color: "#44296a",
              fontSize: "0.95rem",
            }}
          >
            {referencia}
          </strong>

          <div
            style={{
              height: "2px",
              background: "linear-gradient(90deg,#9b2a92,#3d1042)",
              margin: "10px 0 14px",
              borderRadius: "10px",
            }}
          />

          <p
            style={{
              margin: 0,
              fontSize: "0.83rem",
              lineHeight: "1.6",
              textAlign: "justify",
            }}
          >
            {versiculos[referencia]}
          </p>

          <div
            style={{
              marginTop: "12px",
              fontSize: "0.72rem",
              color: "#777",
              textAlign: "right",
              fontStyle: "italic",
            }}
          >
            Reina-Valera 1960
          </div>
        </div>
        
         
      )}
    </span>
  );
}
